<template>
  <div class="content">
    <el-row :gutter="5">
      <el-col :span="12">
        <commission-account></commission-account>
      </el-col>
      <el-col :span="6">
        <el-card class="commission-card">
          <div slot="header" class="clearfix">
            <span>本周佣金</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="commissionClick"  v-hasPermi="['commission:detail:list']">查看详情</el-button>
          </div>
          <el-form label-position="left" inline class="card-table-expand">
            <el-row>
                <el-col :span="24">
                  <el-form-item label="交易单数:" >
                    <span>{{withdrawalCommissionDataWeek.total}}条</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="交易金额:" >
                    <span>{{withdrawalCommissionDataWeek.orderMoney}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="分润金额:" >
                    <span>{{withdrawalCommissionDataWeek.totalRebateAmount}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="实分润金额:" >
                    <span>{{withdrawalCommissionDataWeek.realRebateAmount}}</span>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="commission-card">
          <div slot="header" class="clearfix">
            <span>上周佣金</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="commissionClick" v-hasPermi="['commission:detail:list']">查看详情</el-button>
          </div>
          <el-form label-position="left" inline class="card-table-expand">
            <el-row>
                <el-col :span="24">
                  <el-form-item label="交易单数:" >
                    <span>{{withdrawalCommissionDataLastWeek.total}}条</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="交易金额:" >
                    <span>{{withdrawalCommissionDataLastWeek.orderMoney}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="分润金额:" >
                    <span>{{withdrawalCommissionDataLastWeek.totalRebateAmount}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="实分润金额:" >
                    <span>{{withdrawalCommissionDataLastWeek.realRebateAmount}}</span>
                  </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </el-card>
      </el-col>
  </el-row>
  <el-row style="margin-top:40px;">
    <el-col :span="24">
        <commission-account-chart></commission-account-chart>
    </el-col>
  </el-row>
  </div>
</template>
<script>
import CommissionAccount from "@/components/commission/CommissionAccount.vue";
import CommissionAccountChart from "@/components/commission/CommissionAccountChart.vue";
import {countWithdrawalCommissionWeek} from "@/api/api.js";
export default {
  components: {
    CommissionAccount,
    CommissionAccountChart
  },
  data() {
    return {
      withdrawalCommissionDataWeek:{
        total:0,
        orderMoney:0,
        totalRebateAmount:0,
        realRebateAmount:0
      },
      withdrawalCommissionDataLastWeek:{
        total:0,
        orderMoney:0,
        totalRebateAmount:0,
        realRebateAmount:0
      }
    };
  },
  methods: {
    commissionClick(){
        this.$router.push('/scale/detail')
    },
    withdrawalCommissionDataWeekMethod(){
        let params = {
          type:"1"
        }
        countWithdrawalCommissionWeek(params).then(res=>{
            if(res.data.code == 200){
                this.withdrawalCommissionDataWeek = res.data.data;
            }
        })
    },
    withdrawalCommissionDataLastWeekMethod(){
        let params = {
          type:"2"
        }
        countWithdrawalCommissionWeek(params).then(res=>{
            if(res.data.code == 200){
                this.withdrawalCommissionDataLastWeek = res.data.data;
            }
        })
    }
  },
  mounted() {

  },
  created() {
      this.withdrawalCommissionDataWeekMethod();
      this.withdrawalCommissionDataLastWeekMethod();
  }
};
</script>
<style scoped lang="less">
.commission-card{
  height: 320px;
  .el-col {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .card-table-expand {
    font-size: 14px;
    margin-left: 20px;
    margin-top: 20px;
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 80%;
    }
    label {
      width: 120px;
      font-size: 16px;
      color: #020711;
    }
    span{
      color:#1890ff
    }
  }
}

</style>


